/** @jsx jsx */
import { Text, Title } from '@bottlebooks/gatsby-design-system';
import ProductsListBase from '@bottlebooks/gatsby-theme-event/src/components/ProductsList/ProductsList';
import { jsx } from 'theme-ui';
import { Announcement } from '../../../../components/AnnouncementPage';
import useMinimumStage from '../../../../components/useMinimumStage';

export * from '@bottlebooks/gatsby-theme-event/src/components/ProductsList/ProductsList';

export default function ProductsList(props) {
  const showProducts = useMinimumStage('SHOW_PRODUCTS');
  if (showProducts) {
    return <ProductsListBase {...props} />;
  }
  return (
    <Announcement>
      <Title sx={{ marginBottom: 3.5 }}>Die Weine sind eingekühlt…</Title>
      <Text sx={{ marginBottom: 3 }}>
        …welche Sie verkosten dürfen, erfahren Sie aber erst am{' '}
        <strong sx={{ color: 'primary' }}>
          14.&nbsp;Mai um&nbsp;15:00&nbsp;Uhr
        </strong>
        .
      </Text>

      <Text sx={{ marginBottom: 2 }}>
        Dann ist es soweit, und wir veröffentlichen hier die präsentierten Weine
        und die Finalisten in den 17 Kategorien von &bdquo;Best of
        Burgenland&ldquo;.
      </Text>
    </Announcement>
  );
}
